import BaseServiceHttp from '../baseService'
class Gestores extends BaseServiceHttp {
  constructor(id) {
    const resource = 'gestores'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Gestores(id)
